import { render, staticRenderFns } from "./Alertprofile.vue?vue&type=template&id=63cbe9ec&scoped=true"
import script from "./Alertprofile.vue?vue&type=script&lang=js"
export * from "./Alertprofile.vue?vue&type=script&lang=js"
import style0 from "./Alertprofile.vue?vue&type=style&index=0&id=63cbe9ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cbe9ec",
  null
  
)

export default component.exports